import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { LightboxSiteConfig } from '../types'

const POPUP_CONTAINER_TYPE = 'wysiwyg.viewer.components.PopupContainer'
const POPUP_CLOSE_TEXT_BUTTON = 'wysiwyg.viewer.components.PopupCloseTextButton'
const POPUP_CLOSE_ICON_BUTTON = 'wysiwyg.viewer.components.PopupCloseIconButton'

const lightboxSiteConfig: SiteConfigFn<LightboxSiteConfig> = ({ api }) => {
	const isBuilderComponentModel = !!api.rendererModel.getIsBuilderComponentModel()
	const componentsCountHints = api.rendererModel.getSiteMetaData()?.renderHints?.componentsCount

	const hasPopupComponents = componentsCountHints
		? !!(
				componentsCountHints[POPUP_CONTAINER_TYPE] ||
				componentsCountHints[POPUP_CLOSE_TEXT_BUTTON] ||
				componentsCountHints[POPUP_CLOSE_ICON_BUTTON]
			)
		: true // Default to true when componentsCount is missing

	const shouldLoadSiteFeature = hasPopupComponents || isBuilderComponentModel

	if (!shouldLoadSiteFeature) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	// Get routers and filter by valid platform apps
	const routersConfigMap = api.rendererModel.getRouters()?.configMap ?? {}
	const validRoutersConfigMap: typeof routersConfigMap = {}

	for (const [routerId, routerConfig] of Object.entries(routersConfigMap)) {
		const appDefinitionId = routerConfig.appDefinitionId
		if (api.router.isValidPlatformAppRouterConfig(appDefinitionId)) {
			validRoutersConfigMap[routerId] = routerConfig
		}
	}

	// Build prefixToRouterFetchData mapping
	const prefixToRouterFetchData = api.router.getPrefixToRouterFetchDataMapping(validRoutersConfigMap)

	// Build pageIdToPrefix mapping
	const pageIdToPrefix: Record<string, string> = {}
	for (const routerConfig of Object.values(validRoutersConfigMap)) {
		const prefix = routerConfig.prefix
		const pages = routerConfig.pages || {}
		for (const pageId of Object.values(pages)) {
			pageIdToPrefix[pageId] = prefix
		}
	}

	const siteConfig: LightboxSiteConfig = {
		prefixToRouterFetchData,
		pageIdToPrefix,
		isBuilderComponentModel,
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig,
	}
}

const name = 'lightbox'

export const config = { site: lightboxSiteConfig, name }
